import React from 'react'
import styled from 'styled-components'
import { Icon as StormIcon, Tag } from '@amzn/storm-ui'
import { useEmitInitialRender } from '../../utils/hooks'
import { WidgetTypes } from '../../common/constants'

export interface TagProps {
  type: 'NEW' | 'BETA'
  label: string
  hasInfoCircle?: boolean
  dataTaktId: string
}

const Icon = styled(StormIcon)`
  margin-inline-start: 0.3em;
`

export const LaunchTag: React.FC<TagProps> = ({ type, label, hasInfoCircle, dataTaktId }) => {
  useEmitInitialRender(WidgetTypes.LaunchTag)

  return (
    <Tag
      data-takt-id={dataTaktId}
      type={type.toLowerCase() as 'new' | 'beta' | undefined}
      description={label}
      label={
        <>
          {label}
          {hasInfoCircle && <Icon type="info-circle" size="xs" blockSize />}
        </>
      }
    />
  )
}
